import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PopularPlaceDeleteRequestBody, PopularPlaceDeleteResponse } from "./types";

export class PopularPlaceDeleteAPI extends BaseAPI<
    PopularPlaceDeleteRequestBody,
    PopularPlaceDeleteResponse
> {
    protected route = ApiRoutes.popular_place.delete;
    protected method = RequestMethod.DELETE;
    protected params = ["id"]
}
